import { deleteApi, getApi, postApi, putApi } from "../configAxios";

export const getUsers = (params) => {
  return getApi("/admin/users", params);
};

export const getUser = (id) => {
  return getApi(`/admin/users/${id}`);
};

export const createUser = (data) => {
  return postApi("/admin/users", data);
};

export const updateUser = (id, data) => {
  return putApi(`/admin/users/${id}`, data);
};

export const deleteUser = (id) => {
  return deleteApi(`/admin/users/${id}`);
};

export const getPermissions = () => {
  return getApi("/permissions");
};
